<div>
  <div class="action-block">
    <div class="action-item" (click)="printList()">
      <img style="width: 70px" src="../../../../../assets/images/printer.svg"/>
      <label>{{'event.printList' | translate}}</label>
    </div>
    <div class="action-item" (click)="downloadCode()">
      <img style="width: 70px" src="../../../../../assets/images/pdf.svg"/>
      <label>{{'event.downloadPdf' | translate}}</label>
    </div>
    <div class="action-item" (click)="downloadCSV()">
      <img style="width: 70px" src="../../../../../assets/images/csv.svg"/>
      <label>{{'event.downloadCSV' | translate}}</label>
    </div>
    <div class="action-item" (click)="downloadXLSX()">
      <img style="width: 70px" src="../../../../../assets/images/excel.png"/>
      <label>{{'event.downloadXLSX' | translate}}</label>
    </div>
    @if (data.additionalForm) {
      <div class="action-item" (click)="downloadAllPDF()">
        <img style="width: 70px" src="../../../../../assets/images/pdf.svg"/>
        <label>{{'all_user_info' | translate}}</label>
      </div>
    }
  </div>
</div>
